import { Controller, useFormContext } from 'react-hook-form';
import { TermsAndConditionsFieldProps } from './types';
import { TermsAndConditions } from '../../terms-and-conditions';

export const FormTermsAndConditionsCheck = ({
  name,
  children,
}: React.PropsWithChildren<TermsAndConditionsFieldProps>) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => (
        <TermsAndConditions
          name={name}
          isChecked={field.value}
          onCheckChange={() => field.onChange(!field.value)}
          error={errors[name]?.message as string}
        >
          {children}
        </TermsAndConditions>
      )}
    />
  );
};
